module.exports = __webpack_public_path__ + "static/media/Lifestyle.5ded4843.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/About/Tracks/img/newlogos/Lifestyle.svg
// module id = 246
// module chunks = 0